module.exports = __webpack_public_path__ + "static/media/logo_gestor_bacias_horizontal.282fa585.png";